import React from "react";
import { UseFormRegister } from "react-hook-form";
import Hint from "../../fields/Hint";
import Label from "../Label";
import useRegisterPropOrFromContext from "./useRegisterPropOrFromContext";
import classNames from "classnames";

type InputArgs = {
  name: string;
  label?: string;
  required?: boolean | string;
  defaultValue?: string;
  register?: UseFormRegister<any>;
  options: {
    label: string | React.ReactElement;
    value: string;
    disabled?: boolean;
    hint?: string;
  }[];
  hint?: string;
  withoutWrapper?: boolean;
  onlyOptions?: boolean;
  labelClassName?: string;
  extraElement?: React.ReactElement;
  disabled?: boolean;
};

export default function RadioButton({
  name,
  register,
  label,
  options,
  hint,
  required,
  defaultValue,
  extraElement,
  withoutWrapper = false,
  onlyOptions = false,
  labelClassName,
  disabled = false,
}: InputArgs) {
  register = useRegisterPropOrFromContext(register);

  const renderedOptions = options.map((option) => (
    <div key={option.value}>
      <label
        className={classNames(
          "radio gap-2 items-center",
          { "text-muted": disabled },
          labelClassName,
        )}
      >
        <input
          type="radio"
          value={option.value}
          {...(register ? register(name) : null)}
          defaultChecked={option.value === defaultValue}
          disabled={disabled || option.disabled}
        />
        {option.label}
      </label>
      {option.hint && (
        <div className="ml-8 text-muted text-sm">{option.hint}</div>
      )}
    </div>
  ));

  if (onlyOptions) {
    return <>{renderedOptions}</>;
  }

  return withoutWrapper ? (
    <div className="flex flex-col gap-2 mt-2 items-start">
      {label && <Label label={label} required={!!required} />}
      <div>{renderedOptions}</div>
      {hint && <Hint hint={hint} />}
    </div>
  ) : (
    <div className="control-group">
      {label && <Label label={label} required={!!required} />}
      <div className="controls white-box checkboxes border-box p-3">
        {renderedOptions}
        {hint && <Hint hint={hint} />}
        {extraElement}
      </div>
    </div>
  );
}
